import { render, staticRenderFns } from "./subAddressAdd.vue?vue&type=template&id=58858b4e&scoped=true"
import script from "./subAddressAdd.vue?vue&type=script&lang=js"
export * from "./subAddressAdd.vue?vue&type=script&lang=js"
import style0 from "./subAddressAdd.vue?vue&type=style&index=0&id=58858b4e&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "58858b4e",
  null
  
)

export default component.exports